export default {
  htech: {
    gt: {
      code: 'GTM-N3HSLTB',
      dataLayerName: 'dataLayer'
    },
    sv: {
      code: 'GTM-5ZNG3TG',
      dataLayerName: 'dataLayer'
    },
    hn: {
      code: 'GTM-N6TGL6D',
      dataLayerName: 'dataLayer'
    },
    ni: {
      code: 'GTM-TTTW6Q7',
      dataLayerName: 'dataLayer'
    },
    cr: {
      code: 'GTM-MRZ7R4S',
      dataLayerName: 'dataLayer'
    }
  },
  claro: {
    gt: {
      code: 'GTM-MZZMHG2W',
      dataLayerName: 'claroDataLayer'
    },
    sv: {
      code: 'GTM-N75XBZR4',
      dataLayerName: 'claroDataLayer'
    },
    hn: {
      code: 'GTM-WQ8C7XXM',
      dataLayerName: 'claroDataLayer'
    },
    ni: {
      code: 'GTM-W9DKHXZV',
      dataLayerName: 'claroDataLayer'
    },
    cr: {
      code: 'GTM-NZ5MTFL9',
      dataLayerName: 'claroDataLayer'
    }
  }
}

export const GA_ACCOUNTS = {
  gt: 'UA-126895257-2',
  hn: 'UA-126895257-3',
  ni: 'UA-126895257-7',
  cr: 'UA-126895257-5',
  sv: 'UA-126895257-4',
  pa: 'UA-126895257-6'
}
